module.exports = __webpack_public_path__ + "media/review-badges/rank-1k-1490527b.svg";